/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, DestroyRef, Input, OnInit, inject} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';
import template from './trigger-list-page.component.html';

import {APP_SHARED} from '../common/app-shared';
import {SignalAdminResourceListComponent} from '../common/controller/signal-admin-resource-list.component';
import {SignalAdminListColumn, SignalAdminResourceListStateFactory} from '../common/controller/signal-admin-resource-list-state';
import {TriggerApiService, TriggerModel} from './trigger-api.service';

@Component({
  standalone: true,
  imports: [...APP_SHARED, UIRouterModule, SignalAdminResourceListComponent],
  selector: 'adn-trigger-list-page',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TriggerListPageComponent implements OnInit {
  readonly itemStateName = 'app.dat-seg.triggers.trigger';

  readonly columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {label: 'folders', param: '', sortable: false},
    {label: 'addSegment', param: '', sortable: false},
    {label: 'removeSegment', param: '', sortable: false}
  ];

  readonly list = inject(SignalAdminResourceListStateFactory).create<TriggerModel>(
    inject(TriggerApiService),
    {listId: 'fullTriggerList'},
    inject(DestroyRef)
  );

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    this.list.load();
  }
}
